module.exports = __webpack_public_path__ + "static/media/rekap.7edcd549.png";